export const mbpAppServices = [
  'appointment',
  'report',
  'recycling-calendar',
  'slim-map',
  'library',
  'elections',
];
